/**
* Created by xing.lin on 2019/6/11.
*/
import cookie from '../utils/cookie'
import config from '../config/config'
import ajax from '../utils/ajax'
import md5 from 'vux/src/tools/md5/index.js'
import base64 from 'vux/src/tools/base64/index.js'

import Vue from 'vue'

export function loginSaveData(data, phone, password) {

this.$cookie.set(this.$config.userId, data.userId);
this.$cookie.set(this.$config.tokenId, data.accessToken);
this.$cookie.set(this.$config.userCode, data.userCode);
this.$cookie.set("loginTime", new Date().getTime());
var phone = data.userCode && data.userCode.replace(/^86/,"");
localStorage.setItem("userCode",phone);



if(phone && password){
localStorage.setItem("c", phone);
localStorage.setItem("p", base64.encode(password));
}
}


export function logoutRemoveData(removeCP) { // removeCP 是否删除账户和密码
this.$cookie.remove(this.$config.userCode);
this.$cookie.remove(this.$config.userId);
this.$cookie.remove(this.$config.tokenId);
this.$cookie.remove('c');
this.$cookie.remove('p');
this.$cookie.remove("loginTime");
sessionStorage.clear();
localStorage.removeItem("userCode");
localStorage.removeItem("userName");
localStorage.removeItem("imei");
localStorage.removeItem("isAuthed");
if(removeCP){
removeAccount();
}
}

function removeAccount() {
localStorage.removeItem("c");
localStorage.removeItem("p");
}

function login(userCode, password) {
console.log("main.js中的登录")
this.$ajax({
url: this.$api.login,
method: 'post',
noAuth: true,
data: {
userCode: userCode,
password: md5(password)
}
}).then((res) => {
if(res.resultCode == "00000000"){


this.$saveData(res.data, userCode, password);
var redirectUrl = this.$route.query.redirectUrl;
if(redirectUrl){
this.$router.replace({
name: redirectUrl
});
}else{
this.$router.replace({
name: "home"
});
}
}else{
this.$router.push({
name: "login"
});
}
}).catch( err => {
console.log(err)
})
}

function toast(text, time=2000, cb=null) {
Vue.$vux.toast.show({
type: "text",
text: text,
time: time,
position: "bottom",
onHide: () => {
cb && cb.call(this)
}
});
}


export const isAuthed = async () => {
try{
const authMsg = JSON.parse(localStorage.getItem("authMsg") || "[]"); 
const userId = cookie.getCookie(config.userId);


if(authMsg.includes(userId)){
return true;
}else{
const res = await ajax({
url: config.api.checkUserCode,
method: 'post',
data: {}
});
if(res.resultCode == "00000000"){
if(res.data && res.data.is_reservation_user){
authMsg.push(userId);
localStorage.setItem("authMsg", JSON.stringify(authMsg));
return true;
}else{
return false;
}
}else{
this.$toast("查询预约码出错了");
return false;
}
}
}catch (err){
this.$toast("程序抛锚了");
localStorage.removeItem("authMsg");
console.log(err);
}
}


export function trackPageView(to) { // 统计页面曝光
var _czc = window._czc || [];
if (to.path) {

_czc.push(['_trackPageview', to.path]);
}
}

export default {
install(Vue, options){
Vue.prototype.$api = config.api;
Vue.prototype.$cookie = cookie;
Vue.prototype.$config = config;
Vue.prototype.$ajax = ajax;

Vue.prototype.$saveData = loginSaveData;
Vue.prototype.$removeData = logoutRemoveData;
Vue.prototype.$login = login;
Vue.prototype.$dispatchTouchmove = dispatchTouchmove;

Vue.prototype.$toast = toast;
}
}



// WEBPACK FOOTER //
// ./src/plugins/globalFn.js